import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux';
import auth from './auth'
import event from './event'
import ui from './ui'

export default combineReducers({
    auth,
    event,
    ui,
    router: routerReducer
})


// WEBPACK FOOTER //
// ./src/reducers/index.js